/** localStorage draft for /survey/prevbrand. */
export const PREV_BRAND_STORAGE_KEY = 'ldsurvey:prevBrand';

/** Brand value when the respondent specifies a brand not listed in the catalog. */
export const PREV_BRAND_OTHERS = 'Others';

export type PrevBrandAnswers = {
  brand: string;
  variant: string;
};

export function isOthersPrevBrandBrand(brand: string): boolean {
  return brand.trim().toLowerCase() === PREV_BRAND_OTHERS.toLowerCase();
}

/** Normalizes draft answers so "Others" free-text is always brand=Others, variant=<specify>. */
export function buildPrevBrandAnswers(brand: string, variant: string): PrevBrandAnswers {
  const trimmedVariant = variant.trim();
  if (isOthersPrevBrandBrand(brand)) {
    return { brand: PREV_BRAND_OTHERS, variant: trimmedVariant };
  }
  return { brand: brand.trim(), variant: trimmedVariant };
}

export function readPrevBrandAnswers(): Partial<PrevBrandAnswers> | null {
  try {
    const raw = localStorage.getItem(PREV_BRAND_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (typeof parsed !== 'object' || parsed === null) return null;
    const p = parsed as Record<string, unknown>;
    return {
      brand: typeof p.brand === 'string' ? p.brand : '',
      variant: typeof p.variant === 'string' ? p.variant : '',
    };
  } catch {
    return null;
  }
}

export function writePrevBrandAnswers(data: PrevBrandAnswers): void {
  try {
    localStorage.setItem(
      PREV_BRAND_STORAGE_KEY,
      JSON.stringify(buildPrevBrandAnswers(data.brand, data.variant))
    );
  } catch {
    /* ignore */
  }
}

export function clearPrevBrandAnswers(): void {
  try {
    localStorage.removeItem(PREV_BRAND_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isPrevBrandComplete(): boolean {
  const s = readPrevBrandAnswers();
  return !!s?.brand?.trim() && !!s?.variant?.trim();
}
